export const views = {
  SCHOOLS: "schools",
  STATES: "states",
  STATE_SCHOOLS: "schools",
  STATE_DISTRICTS: "districts",
  S4S_GRANTEES: "solar-for-schools-grant-program",
};

export const stateCodes = {
  PA: "PA",
  VA: "VA",
  MD: "MD",
};

export const stateCodeToName = {
  [stateCodes.PA]: "Pennsylvania",
  [stateCodes.VA]: "Virginia",
  [stateCodes.MD]: "Maryland",
};

export const viewToRoute = {
  [views.SCHOOLS]: "schools",
  [views.STATES]: "states",
  [views.STATE_SCHOOLS]: "schools",
  [views.STATE_DISTRICTS]: "districts",
  [views.S4S_GRANTEES]: "solar-for-schools-grant-program",
};

export const mapModes = {
  STATE: "state",
  MEA: "mea",
};

export const statesViews = {
  CAPACITY: "capacity",
  PERCENT_SCHOOLS: "percent-schools",
};
